import { getUsersName } from "@/api/users/helpers";
import { EndemicUserWrapper } from "@/app/(components)/Basic/EndemicUserWrapper";
import { FollowingButton } from "@/app/(components)/Basic/FollowingButton";
import { ImageTypeHandler } from "@/app/(components)/Basic/ImageTypeHandler";
import { ReactTable } from "@/app/(components)/Basic/ReactTable";
import { User } from "@sentry/nextjs";
import { UserLink } from "../../User/UserLink";
import DefaultProfile from "@/assets/graphics/default-profile.svg";
import FollowStarIcon from "@/assets/icons/follow-star.svg";

export interface Props {
  follows: (User | undefined)[];
  followCount: number;
  hasNextPage: boolean | undefined;
  fetchNextPage: () => void;
  label: string;
  displayEmail?: boolean;
}

const ProfileFollowTable = ({
  follows,
  followCount,
  hasNextPage,
  fetchNextPage,
  label,
  displayEmail = false,
}: Props) => {
  const columns = [
    {
      Header: "",
      accessor: "user",
      Cell: ({ row }: any) => (
        <div className="flex items-center w-fit">
          <UserLink artist={row.original} tooltipPosition={["center", "top"]}>
            <div className="relative box-content w-20 h-20 rounded-full overflow-hidden top-6 lg:top-0">
              {row.original.imageUrl ? (
                <ImageTypeHandler
                  alt="Profile image"
                  src={row.original.imageUrl}
                  placeholder={row.original.imagePlaceholder}
                  fill
                />
              ) : (
                <DefaultProfile />
              )}
            </div>
          </UserLink>
          <UserLink artist={row.original} tooltipPosition={["right", "middle"]}>
            <div className="flex flex-col ml-5 lg:ml-9">
              <EndemicUserWrapper id={row.original.id}>
                <span className="text-lg font-light lg:text-3xl">
                  {getUsersName(row.original, true, displayEmail)}
                </span>
              </EndemicUserWrapper>
              <span className="text-secondary">{row.original.displayName}</span>
            </div>
          </UserLink>
        </div>
      ),
    },
    {
      Header: "",
      accessor: "following",
      Cell: ({ row }: any) => (
        <span className="min-h-[40px]">
          <FollowingButton userId={row.original.id} />
        </span>
      ),
    },
  ];

  return (
    <>
      <div className="flex flex-col lg:flex-row items-center mb-10 gap-y-6 justify-between">
        <div className="flex gap-x-4">
          <FollowStarIcon className="w-6 fill-grey" />
          <span className="text-lg font-light whitespace-nowrap">
            {`Total ${label}`}
            <span className="font-semibold ml-3">{followCount}</span>
          </span>
        </div>
      </div>
      <ReactTable
        columns={columns}
        data={follows}
        showMoreButton={hasNextPage}
        hideColumnHeader
        className="border-t border-grey"
        rowClassName="flex-col w-full py-4"
        cellClassName="w-full lg:w-auto py-0 lg:py-6"
        showMoreHandler={fetchNextPage}
      />
    </>
  );
};

export default ProfileFollowTable;
